import { SquareAsterisk } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SquareAsteriskIcon = createLucideIcon(SquareAsterisk);
